import {
  ISpatialReferenceRepository,
  SpatialReferenceEntity,
  MouseProjectionEnum,
} from '@gishub/domain';

export class SpatialReferenceRepository implements ISpatialReferenceRepository {
  private static readonly references: Array<{
    projection: MouseProjectionEnum;
    wkid: number;
    label: string;
    code: string;
  }> = [
    { projection: MouseProjectionEnum.Wgs84, wkid: 4326, label: 'Geográficas WGS84', code: 'EPSG:4326' },
    { projection: MouseProjectionEnum.Utm17S, wkid: 32717, label: 'UTM Zona 17S', code: 'EPSG:32717' },
    { projection: MouseProjectionEnum.Utm18S, wkid: 32718, label: 'UTM Zona 18S', code: 'EPSG:32718' },
    { projection: MouseProjectionEnum.Utm19S, wkid: 32719, label: 'UTM Zona 19S', code: 'EPSG:32719' },
  ];

  getAll(): SpatialReferenceEntity[] {
    return SpatialReferenceRepository.references.map(r => new SpatialReferenceEntity({
      projection: r.projection,
      wkid: r.wkid,
      label: r.label,
      code: r.code,
    }));
  }

  getWkidByProjection(projection: MouseProjectionEnum): number {
    return SpatialReferenceRepository.references.find(r => r.projection === projection)?.wkid ?? 4326;
  }

  getProjectionByWkid(wkid: number): MouseProjectionEnum {
    return SpatialReferenceRepository.references.find(r => r.wkid === wkid)?.projection ?? MouseProjectionEnum.Wgs84;
  }
}